<template>
    <ui-dialog class="html-editor-tiptap-toolbar-upload" :open.sync="isOpen" :closeScrim=false>
      <template #contents>
        <div class="HtmlEditorToolbarUpload">
          <h1>{{ isLink ? $t('HtmlEditorToolbarUpload.insertEditLink') : $t('HtmlEditorToolbarUpload.insertEditImage') }}</h1> <br>

          <div class="HtmlEditorToolbarUpload__upload">
            <div style="width: 20%;">{{ $t('HtmlEditorToolbarUpload.link') }}</div>
            <div style="flex-grow: 1;">
              <UiInput class="inputUrl" type="text" v-model="inputUrl" @input="setUrl(inputUrl)" />
            </div>
            <div>
              <UiIcon style="cursor: pointer;" value="mdi:folder-search-outline" @click="openFileInput" />
            </div>
          </div>

          <template v-if="isLink">
            <div class="HtmlEditorToolbarUpload__option" v-if="!isLinkImage">
              <div style="width: 20%;">{{ $t('HtmlEditorToolbarUpload.textToDisplay') }}</div>
              <div style="flex-grow: 1;"><UiInput class="inputUrl" type="text" v-model="inputText" /></div>
            </div>

            <div class="HtmlEditorToolbarUpload__option">
              <div style="width: 20%;">{{ $t('HtmlEditorToolbarUpload.newWindow') }}</div>
              <div style="flex-grow: 1;"><input type="checkbox" v-model="inputNewWindow" /></div>
            </div>
          </template>

          <template v-else>
            <div class="HtmlEditorToolbarUpload__dimensions" v-if="previews.length">
              <div>{{ $t('HtmlEditorToolbarUpload.dimensions') }}</div>
              <div style="width: 15%;"><UiInput type="text" v-model="width" class="styles" @change="onchangeWidth" /></div>
              <div>x</div>
              <div style="width: 15%;"><UiInput type="text" v-model="height" class="styles" @change="onchangeHeight" /></div>
              <div><input type="checkbox" v-model="restrictDimensions" /> {{ $t('Restrict dimensions') }}</div>
            </div>

            <div class="HtmlEditorToolbarUpload__dimensions" v-if="previews.length">
              <div>{{ $t('HtmlEditorToolbarUpload.rotateImage') }}</div>
              <UiIcon style="cursor: pointer;" value="mdi:rotate-left" @click="rotate('left')" />
              <UiIcon style="cursor: pointer;" value="mdi:rotate-right" @click="rotate('right')" />
              <div>|</div>
              <UiIcon style="cursor: pointer;" value="mdi:horizontal-rotate-counterclockwise" @click="rotate('horizontal')" />
              <UiIcon style="cursor: pointer;" value="mdi:axis-z-rotate-clockwise" @click="rotate('vertical')" />
            </div>
          </template>

          <UiLoading v-if="loader" :label="$t('HtmlEditorToolbarUpload.loading')" />
          <div class="HtmlEditorToolbarUpload__previews">
            <div v-for="(preview, i) in previews" :style="'width: 30%; transform:'+descriptionRotation+';'"><img v-if="!isLink" width="100%" height="100%" :src="preview"></div>
          </div>
        </div>

        <phi-filesystem-folder
            v-if="isOpenFolder"
            :url="uploadsUrl"
            :api="app.api"
            @select="selectImage"
        ></phi-filesystem-folder>
      </template>

      <template #footer>
        <button
          type="button"
          class="ui-native --main"
          @click="onAccept"
        >{{ $t('HtmlEditorToolbarUpload.accept') }}</button>
        <button
          type="button"
          class="ui-native --cancel"
          @click="onCancel"
        >{{ $t('HtmlEditorToolbarUpload.cancel') }}</button>
      </template>
    </ui-dialog>
  </template>

  <script>
  import { UiDialog, UiIcon, UiInput, UiLoading } from '@/modules/ui/components';

  import PhiFilesystemFolder from './../../../../../components/Phi/Filesystem/Folder.vue';

  import useI18n from '@/modules/i18n/mixins/useI18n.js';
  import app from '../../../../../store/app.js';

  export default {
    components: {
      UiDialog,
      UiIcon,
      UiInput,
      UiLoading,
      PhiFilesystemFolder
    },

    props: {
      isOpen: {
        type: Boolean,
        required: false,
        default: false,
      },
      isLink: {
        type: Boolean,
        required: false,
        default: false,
      },
      isLinkImage: {
        type: Boolean,
        required: false,
        default: false,
      },
      urlDefault: {
        type: Object,
        default: null,
      }
    },

    mixins: [useI18n],

    data() {
      return {
        app,
        urls: [],
        width: 0,
        files: [],
        height: 0,
        rotation: 0,
        previews: [],
        inputUrl: '',
        inputText: '',
        loader: false,
        originalWidth: 0,
        originalHeight: 0,
        isOpenFolder: false,
        inputNewWindow: false,
        descriptionRotation: '',
        restrictDimensions: false,
        uploadsUrl: app.user ? `/people/${app.user.id}/uploads` : '/people/anon/uploads'
      }
    },

    watch: {
      urlDefault: function(newVal) {
        if (newVal.src) {
          var text = newVal.style ? newVal.style.split(':') : ['', ''];

          if (/rotate\(-?\d+deg\);/.test(text[1])) {
            var numeroExtraido = text[1].match(/rotate\((-?\d+)deg\);/);
          } else if (/scaleY\((-?\d+)\);/.test(text[1])) {
            var numeroExtraido = text[1].match(/scaleY\((-?\d+)\);/);
          } else if (/scaleX\((-?\d+)\);/.test(text[1])) {
            var numeroExtraido = text[1].match(/scaleX\((-?\d+)\);/);
          } else {
            var numeroExtraido = ['rotate(0deg);', '0'];
          }

          this.descriptionRotation = numeroExtraido[0];
          this.rotation = parseInt(numeroExtraido[1]);
          this.inputUrl = newVal.src;
          this.inputNewWindow = newVal.target == "_blank";
          this.width = newVal.width;
          this.height = newVal.height;
          this.urls.push(newVal.src);
          this.previews.push(newVal.src);
        }

        this.inputText = newVal.text;
      },
    },

    methods: {
      onchangeWidth() {
        if(this.width && this.restrictDimensions) {
          let operation1 = (this.originalHeight / this.originalWidth) * this.width;
          this.height = operation1 ? Math.round(operation1) : 0;
        }
      },
      onchangeHeight() {
        if(this.height && this.restrictDimensions) {
          let operation = ((this.originalWidth / this.originalHeight) * this.height)
          this.width = operation ? Math.round(operation) : 0;
        }
      },
      onAccept() {
        if(this.isLink) {
          this.urls.inputText = this.inputText;
          this.urls.inputNewWindow = this.inputNewWindow;
          this.urls.url = this.inputUrl;
        } else {
          this.urls.splice(0, 0, {width: this.width, height: this.height, rotation: this.descriptionRotation});
        }
        this.$emit('setUrl', this.urls);
        this.$emit('close');
        this.urls = [];
        this.files = [];
        this.previews = [];
        this.inputUrl = "";
        this.width = 0;
        this.height = 0;
        this.rotation = 0;
        this.isOpenFolder
        this.descriptionRotation = '';
        this.inputText = '';
        this.inputNewWindow = false;
      },

      onCancel() {
        this.$emit('close');
        this.urls = [];
        this.files = [];
        this.previews = [];
        if (!this.urlDefault || this.inputUrl){
          this.inputUrl = "";
        }
        this.width = 0;
        this.height = 0;
        this.rotation = 0;
        this.descriptionRotation = '';
        this.inputText = '';
        this.inputNewWindow = false;
      },

      setUrl(url) {
        if (!url) {
          return;
        }

        const image_tmp = new Image();
        image_tmp.onload = () => {
          this.width = image_tmp.width;
          this.originalWidth = image_tmp.width;
          this.height = image_tmp.height;
          this.originalHeight = image_tmp.height;
          this.restrictDimensions = true;
        };
        image_tmp.src = url;

        if(this.isLink) {
          this.inputText = this.inputText ? this.inputText : url;
          this.previews = [];
        }
        this.previews.push(url);
        this.urls.push(url);
      },

      openFileInput() {
        this.isOpenFolder = true;
      },

      selectImage(image) {
        if(this.isLink) {
          this.inputUrl = image.url;
          this.previews = [];
          this.urls = [];
        }

        this.setUrl(image.url);

        this.isOpenFolder = false;
      },

      rotate(event) {
        if (event === "right") {
          this.rotation = this.rotation + 90;
          this.descriptionRotation = 'rotate('+this.rotation+'deg)'
        }

        if (event === "left") {
          this.rotation = this.rotation - 90;
          this.descriptionRotation = 'rotate('+this.rotation+'deg)'
        }

        if (event === "horizontal") {
          if (this.rotation === -1) {
            this.rotation = 1;
            this.descriptionRotation = 'scaleY(1)'
          } else {
            this.rotation = -1;
            this.descriptionRotation = 'scaleY(-1)'
          }
        }

        if (event === "vertical") {
          if (this.rotation === -1) {
            this.rotation = 1;
            this.descriptionRotation = 'scaleX(1)'
          } else {
            this.rotation = -1;
            this.descriptionRotation = 'scaleX(-1)'
          }
        }
      },
    },

    i18n: {
      en: {
        'HtmlEditorToolbarUpload.link': 'Link',
        'HtmlEditorToolbarUpload.cancel': 'Cancel',
        'HtmlEditorToolbarUpload.accept': 'Accept',
        'HtmlEditorToolbarUpload.loading': 'Loading',
        'HtmlEditorToolbarUpload.dimensions': 'Dimensions',
        'HtmlEditorToolbarUpload.insertEditLink': 'Insert/edit link',
        'HtmlEditorToolbarUpload.insertEditImage': 'Insert/edit image',
        'HtmlEditorToolbarUpload.rotateImage': 'Rotate image',
        'HtmlEditorToolbarUpload.textToDisplay': 'Text to display',
        'HtmlEditorToolbarUpload.newWindow': 'Open in new window',
        'Restrict dimensions': 'Restrict dimensions',
      },

      es: {
        'HtmlEditorToolbarUpload.link': 'Enlace',
        'HtmlEditorToolbarUpload.cancel': 'Cancelar',
        'HtmlEditorToolbarUpload.accept': 'Aceptar',
        'HtmlEditorToolbarUpload.loading': 'Cargando',
        'HtmlEditorToolbarUpload.dimensions': 'Dimensiones',
        'HtmlEditorToolbarUpload.insertEditLink': 'Insertar/editar enlace',
        'HtmlEditorToolbarUpload.insertEditImage': 'Insertar/editar imagen',
        'HtmlEditorToolbarUpload.rotateImage': 'Girar imagen',
        'HtmlEditorToolbarUpload.textToDisplay': 'Texto a mostrar',
        'HtmlEditorToolbarUpload.newWindow': 'Abrir nueva ventana',
        'Restrict dimensions': 'Restringir dimensiones',
      },

      de: {
        'HtmlEditorToolbarUpload.link': 'Link',
        'HtmlEditorToolbarUpload.cancel': 'Abbrechen',
        'HtmlEditorToolbarUpload.accept': 'Akzeptieren',
        'HtmlEditorToolbarUpload.loading': 'Laden',
        'HtmlEditorToolbarUpload.dimensions': 'Abmessungen',
        'HtmlEditorToolbarUpload.insertEditLink': 'Link einfügen/bearbeiten',
        'HtmlEditorToolbarUpload.insertEditImage': 'Bild einfügen/bearbeiten',
        'HtmlEditorToolbarUpload.rotateImage': 'Bild rotieren',
        'HtmlEditorToolbarUpload.textToDisplay': 'Anzuzeigender Text',
        'HtmlEditorToolbarUpload.newWindow': 'In einem neuen Fenster öffnen',
        'Restrict dimensions': 'Abmessungen einschränken',
      },
    },
  }
  </script>

  <style lang="scss">
  .html-editor-tiptap-toolbar-upload .ui-dialog-container {
    max-height: 50% !important;
    max-width: 600px !important;
    top: 30% !important;
    bottom: 10% !important;
  }

  .inputUrl input, .styles input {
    width: 100%;
  }

  .HtmlEditorToolbarUpload {
    &__upload {
      gap: 15px;
      display: flex;
      align-items: center;
    }
    &__option {
      gap: 15px;
      display: flex;
      align-items: center;
      margin-top: 15px;
    }
    &__dimensions {
      gap: 15px;
      width: 100%;
      display: flex;
      margin-top: 20px;
      align-items: center;
      flex-wrap: wrap;
    }
    &__previews {
      gap: 15px;
      width: 100%;
      display: flex;
      flex-wrap: wrap;
      margin-top: 20px;
      overflow-x: auto;
      overflow-y: hidden;
    }
  }
  </style>